export default "__VITE_ASSET__1xR2sHHu__"